import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/sales-invoices/:salesInvoiceId/export-pdf`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const exportPDF = {
  post: apiPathFunc(pathBase),
};
